import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';

import { selectTimeZone } from '../store/intl/selectors';
import { checkJoinability, query } from '../lib/game-utils/check-joinability';

export function useCheckJoinability({ gameId, gameType }) {
  const timeZone = useSelector(selectTimeZone);
  const skip = !gameId || !gameType || !timeZone;

  const { data, loading, error } = useQuery(query, {
    fetchPolicy: 'network-only',
    ssr: false,
    variables: { gameId, gameIdAsID: gameId, gameType, timeZone },
    skip,
  });
  const game = data?.game || {};

  if (loading || error || skip) return { error, loading };

  return checkJoinability(game);
}
